import {
    Camera,
    Check,
    Square,
    Circle,
    Slash,
    MoveDownLeft,
    Pencil,
    Smile,
    Undo,
    Redo,
    ChevronRight,
    ChevronDown,
    ChevronUp,
    RotateCcw,
    ZoomIn,
    ZoomOut,
    Hand,
    Crop,
    FlipHorizontal2,
    FlipVertical2,
    Sunset,
    Box,
    LayoutGrid,
    ImagePlus,
    Type,
    CodeXml,
    ClipboardPaste,
    ImagePlay,
    Maximize,
    ListCollapse,
    ArrowUpRight,
    ArrowDownRight,
    ImageDown,
    Copy,
    Settings2,
    ChevronLeft,
    Pipette,
    Trash2,
    Sun,
    Moon,
    MessageCirclePlus,
    Home,
    BookOpen,
    Info,
    Menu,
    Upload,
    Link,
    Monitor,
    Palette,
    Edit3,
    Download,
    Zap,
    Sparkles,
    Users,
    AtSign,
    Share2,
    Github,
    MessageSquare,
    MessageCircle,
    FileText,
    Sticker,
    Sliders,
    Layers,
    Grid,
    Shield,
    HelpCircle,
    Clock,
    Play,
    Rocket,
    User,
    Award,
    Copyright,
    Edit,
    Layout,
    Globe,
    RefreshCw,
    Lock,
    Server,
    UserCheck,
    AlertTriangle,
    Flag,
    CheckSquare,
    Image,
    Mail,
    ArrowRight,
    Briefcase,
    Scissors,
    Minimize2,
    Video,
    Tag,
    Edit2,
    PenTool,
    MousePointer,
    MoveVertical,
    TextSelect,
    BarChartHorizontal,
    Keyboard
} from 'lucide-react';

// 导入 Font Awesome 组件和图标
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCamera, faCheck, faSquare, faCircle, faSlash, 
    faPencil, faFaceSmile, faUndo, faRedo, faChevronRight,
    faChevronDown, faChevronUp, faRotateLeft, faSearchPlus,
    faSearchMinus, faHand, faCrop, faRotate, faSun, 
    faBox, faTableCells, faFileImage, faFont, faCode, 
    faPaste, faImage, faMaximize, faList, faArrowUp,
    faArrowDown, faDownload, faCopy, faGear, 
    faChevronLeft, faEyeDropper, faTrash, faMoon, 
    faCommentDots, faHome, faBook, faInfo,
    faBars, faUpload, faLink, faDesktop, faPalette,
    faPenToSquare, faBolt, faStar,
    faUsers, faAt, faShare, faComment,
    faFileText, faNoteSticky, faSliders,
    faLayerGroup, faTableCellsLarge, faShield,
    faCircleQuestion, faClock, faPlay, faRocket,
    faUser, faAward, faCopyright, faEdit, 
    faTable, faGlobe, faArrowRotateRight, 
    faLock, faServer, faUserCheck, faTriangleExclamation, 
    faFlag, faSquareCheck, faImage as faImageSimple, 
    faEnvelope, faArrowRight, faBriefcase, faScissors,
    faMinimize, faVideo, faTag, faPenNib, faMouse,
    faArrowsUpDown, faHighlighter, faChartBar, faKeyboard
} from '@fortawesome/free-solid-svg-icons';

// 导入品牌图标
import { faGithub } from '@fortawesome/free-brands-svg-icons';

// 创建一个将 lucide 图标名称映射到 Font Awesome 组件和图标的对象
const faIcons = {
    Camera: { icon: faCamera },
    Check: { icon: faCheck },
    Square: { icon: faSquare },
    Circle: { icon: faCircle },
    Slash: { icon: faSlash },
    MoveDownLeft: { icon: faArrowDown },
    Pencil: { icon: faPencil },
    Smile: { icon: faFaceSmile },
    Undo: { icon: faUndo },
    Redo: { icon: faRedo },
    ChevronRight: { icon: faChevronRight },
    ChevronDown: { icon: faChevronDown },
    ChevronUp: { icon: faChevronUp },
    RotateCcw: { icon: faRotateLeft },
    ZoomIn: { icon: faSearchPlus },
    ZoomOut: { icon: faSearchMinus },
    Hand: { icon: faHand },
    Crop: { icon: faCrop },
    FlipHorizontal2: { icon: faRotate, transform: { flipX: true } },
    FlipVertical2: { icon: faRotate, transform: { flipY: true } },
    Sunset: { icon: faSun },
    Box: { icon: faBox },
    LayoutGrid: { icon: faTableCells },
    ImagePlus: { icon: faFileImage },
    Type: { icon: faFont },
    CodeXml: { icon: faCode },
    ClipboardPaste: { icon: faPaste },
    ImagePlay: { icon: faImage },
    Maximize: { icon: faMaximize },
    ListCollapse: { icon: faList },
    ArrowUpRight: { icon: faArrowUp },
    ArrowDownRight: { icon: faArrowDown },
    ImageDown: { icon: faDownload },
    Copy: { icon: faCopy },
    Settings2: { icon: faGear },
    ChevronLeft: { icon: faChevronLeft },
    Pipette: { icon: faEyeDropper },
    Trash2: { icon: faTrash },
    Sun: { icon: faSun },
    Moon: { icon: faMoon },
    MessageCirclePlus: { icon: faCommentDots },
    Home: { icon: faHome },
    BookOpen: { icon: faBook },
    Info: { icon: faInfo },
    Menu: { icon: faBars },
    Upload: { icon: faUpload },
    Link: { icon: faLink },
    Monitor: { icon: faDesktop },
    Palette: { icon: faPalette },
    Edit3: { icon: faPenToSquare },
    Download: { icon: faDownload },
    Zap: { icon: faBolt },
    Sparkles: { icon: faStar },
    Users: { icon: faUsers },
    AtSign: { icon: faAt },
    Share2: { icon: faShare },
    Github: { icon: faGithub },
    MessageSquare: { icon: faComment },
    MessageCircle: { icon: faCommentDots },
    FileText: { icon: faFileText },
    Sticker: { icon: faNoteSticky },
    Sliders: { icon: faSliders },
    Layers: { icon: faLayerGroup },
    Grid: { icon: faTableCellsLarge },
    Shield: { icon: faShield },
    HelpCircle: { icon: faCircleQuestion },
    Clock: { icon: faClock },
    Play: { icon: faPlay },
    Rocket: { icon: faRocket },
    User: { icon: faUser },
    Award: { icon: faAward },
    Copyright: { icon: faCopyright },
    Edit: { icon: faEdit },
    Layout: { icon: faTable },
    Globe: { icon: faGlobe },
    RefreshCw: { icon: faArrowRotateRight },
    Lock: { icon: faLock },
    Server: { icon: faServer },
    UserCheck: { icon: faUserCheck },
    AlertTriangle: { icon: faTriangleExclamation },
    Flag: { icon: faFlag },
    CheckSquare: { icon: faSquareCheck },
    Image: { icon: faImageSimple },
    Mail: { icon: faEnvelope },
    ArrowRight: { icon: faArrowRight },
    Briefcase: { icon: faBriefcase },
    Scissors: { icon: faScissors },
    Minimize2: { icon: faMinimize },
    Video: { icon: faVideo },
    Tag: { icon: faTag },
    Edit2: { icon: faPenNib },
    PenTool: { icon: faPenNib },
    MousePointer: { icon: faMouse },
    MoveVertical: { icon: faArrowsUpDown },
    TextSelect: { icon: faHighlighter },
    BarChartHorizontal: { icon: faChartBar },
    Keyboard: { icon: faKeyboard }
};

// 创建兼容的图标组件，可以同时支持 lucide 和 Font Awesome
const createCompatibleComponent = (LucideComponent, faIconData) => {
    return (props) => {
        // 如果使用 Font Awesome
        if (props.useFa) {
            const { transform, icon } = faIconData;
            return <FontAwesomeIcon icon={icon} transform={transform} {...props} />;
        }
        // 默认使用 lucide
        return <LucideComponent {...props} />;
    };
};

// 创建导出对象
const iconComponents = {};

// 为每个图标创建兼容组件
Object.keys(faIcons).forEach(iconName => {
    // 获取 lucide 组件，不使用 eval
    const lucideComponents = {
        Camera, Check, Square, Circle, Slash, MoveDownLeft, Pencil, Smile, Undo, Redo,
        ChevronRight, ChevronDown, ChevronUp, RotateCcw, ZoomIn, ZoomOut, Hand, Crop,
        FlipHorizontal2, FlipVertical2, Sunset, Box, LayoutGrid, ImagePlus, Type, CodeXml,
        ClipboardPaste, ImagePlay, Maximize, ListCollapse, ArrowUpRight, ArrowDownRight,
        ImageDown, Copy, Settings2, ChevronLeft, Pipette, Trash2, Sun, Moon,
        MessageCirclePlus, Home, BookOpen, Info, Menu, Upload, Link, Monitor, Palette,
        Edit3, Download, Zap, Sparkles, Users, AtSign, Share2, Github, MessageSquare,
        MessageCircle, FileText, Sticker, Sliders, Layers, Grid, Shield, HelpCircle,
        Clock, Play, Rocket,
        User, Award, Copyright, Edit, Layout, Globe, RefreshCw, Lock, Server, UserCheck,
        AlertTriangle, Flag, CheckSquare, Image, Mail, ArrowRight, Briefcase, Scissors,
        Minimize2, Video, Tag, Edit2, PenTool, MousePointer, MoveVertical, TextSelect,
        BarChartHorizontal, Keyboard
    };
    
    const LucideComponent = lucideComponents[iconName];
    const faIconData = faIcons[iconName];
    
    if (LucideComponent && faIconData) {
        iconComponents[iconName] = createCompatibleComponent(LucideComponent, faIconData);
    }
});

export default {
    ...iconComponents,
    // 保留原始组件以保持兼容性
    Camera,
    Check,
    Square,
    Circle,
    Slash,
    MoveDownLeft,
    Pencil,
    Smile,
    Undo,
    Redo,
    ChevronRight,
    ChevronDown,
    ChevronUp,
    RotateCcw,
    ZoomIn,
    ZoomOut,
    Hand,
    Crop,
    FlipHorizontal2,
    FlipVertical2,
    Sunset,
    Box,
    LayoutGrid,
    ImagePlus,
    Type,
    CodeXml,
    ClipboardPaste,
    ImagePlay,
    Maximize,
    ListCollapse,
    ArrowUpRight,
    ArrowDownRight,
    ImageDown,
    Copy,
    Settings2,
    ChevronLeft,
    Pipette,
    Trash2,
    Sun,
    Moon,
    MessageCirclePlus,
    Home,
    BookOpen,
    Info,
    Menu,
    Upload,
    Link,
    Monitor,
    Palette,
    Edit3,
    Download,
    Zap,
    Sparkles,
    Users,
    AtSign,
    Share2,
    Github,
    MessageSquare,
    MessageCircle,
    FileText,
    Sticker,
    Sliders,
    Layers,
    Grid,
    Shield,
    HelpCircle,
    Clock,
    Play,
    Rocket,
    User,
    Award,
    Copyright,
    Edit,
    Layout,
    Globe,
    RefreshCw,
    Lock,
    Server,
    UserCheck,
    AlertTriangle,
    Flag,
    CheckSquare,
    Image,
    Mail,
    ArrowRight,
    Briefcase,
    Scissors,
    Minimize2,
    Video,
    Tag,
    Edit2,
    PenTool,
    MousePointer,
    MoveVertical,
    TextSelect,
    BarChartHorizontal,
    Keyboard
};
